import type { TaskSummary } from './api';
import { phoneModelLabel } from './phonePresentation';

/** Shared by the home task preview and full task list. */
export function taskDetail(task: TaskSummary): string {
  const c = task.context ?? {};
  const lines: string[] = [];
  if (task.resourceType === 'STOCK_TRANSFER') {
    if(c.source&&c.target)lines.push(`${c.source} → ${c.target}`);
    if(c.quantity!=null)lines.push(`${c.quantity} phones${c.model?' · '+phoneModelLabel(c.model):''}`);
  } else if (task.resourceType === 'PICKUP') {
    lines.push([c.agent, c.quantity == null ? undefined : `${c.quantity} phone${c.quantity === 1 ? '' : 's'}`].filter(Boolean).join(' · '));
  } else if (task.resourceType === 'STOCK_IN' || task.resourceType === 'DEVICE') {
    if (c.agent) lines.push(c.agent);
    if (c.model) lines.push(phoneModelLabel(c.model));
    if (c.imeis) lines.push(`IMEI: ${c.imeis}`);
  } else if (task.resourceType === 'STOCKTAKE' && c.expected != null && c.scanned != null) {
    lines.push(`${c.scanned} scanned · ${c.expected} expected`);
  }
  if (c.point&&task.resourceType!=='STOCK_TRANSFER') lines.push(c.point);
  if (task.dueAt && Number.isFinite(Date.parse(task.dueAt))) lines.push(`Due ${new Intl.DateTimeFormat(undefined, { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' }).format(new Date(task.dueAt))}`);
  return lines.filter(Boolean).join('\n');
}

export const taskRoute=(taskType:string,resourceType:string,id:string)=>taskType==='RETURN_RECOVERY'?'/phones-with-agents?status=OVERDUE':resourceType==='STOCK_TRANSFER'?`/stock-transfers/${id}`:resourceType==='AGENT_TRANSFER'?`/agent-transfers/${id}`:resourceType==='REALLOCATION'?`/reallocations/${id}`:taskType==='UNSOLD_RETURN'?'/unsold-return':resourceType==='ONBOARDING'?`/onboarding/${id}`:resourceType==='CUSTOMER_RETURN'?`/return-reviews/${id}`:resourceType==='STOCK_IN'?`/stock-in/${id}`:resourceType==='STOCKTAKE'?`/stocktakes/${id}`:resourceType==='PICKUP'?`/pickups/${id}`:undefined;
